export const GET_ADVERTISER_PRE_PING = 'GET_ADVERTISER_PRE_PING';
export const UPDATE_ADVERTISER_PRE_PING = 'UPDATE_ADVERTISER_PRE_PING';
export const CREATE_ADVERTISER_PRE_PING = 'CREATE_ADVERTISER_PRE_PING';
export const UPDATE_ADVERTISER_PRE_PING_ERROR = 'UPDATE_ADVERTISER_PRE_PING_ERROR';